
import { Injectable } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import {Observable, pipe, throwError} from 'rxjs';

import {MessageService} from '../message.service';

import {map, tap} from 'rxjs/operators';
import decode from 'jwt-decode';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import {AppSettings} from '../settings';
import{ArticleService} from './article.service'

import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private message: string;

  constructor(private articleService:ArticleService,private msg:MessageService,private _router: Router,private http: HttpClient ,private toastr: ToastrService,private _activatedRoute: ActivatedRoute) {


   }



  /**
   * this is used to clear anything that needs to be removed
   */
  clear(): void {
    localStorage.clear();
  }

  /**
   * check for expiration and if token is still existing or not
   * @return {boolean}
   */


  isBoolAuthenticated(): any {



    try{



      let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

      if(!tokenA) throw 'Error in parse';

      if(!JSON.parse(tokenA)) throw 'Error in json parse';


      tokenA = JSON.parse(tokenA);


     try{


       let  httpOptions = {
         headers: new HttpHeaders({
           'Content-Type':  'application/json',
           "Authorization": "Bearer "+tokenA.token,
         })
       };



       let api_url =AppSettings.API_ENDPOINT+'auth.php';



       let promise = new Promise((resolve, reject) => {
        let api_url =AppSettings.API_ENDPOINT+'auth.php';
        this.http.post<any>(api_url,{},httpOptions)
          .toPromise()
          .then(
            res => { // Success


               if(res.status=='success'){

                localStorage.setItem('pending_external', res.pending_external ? res.pending_external : 0);

                resolve(true);

               }else{

                 this._router.navigate(['/login']);
                resolve(false);

               }


            },
            msg => { // Error

              reject(false);
              }
          );
      });
      return promise;






     //  return this.http.post<any>(api_url,{},httpOptions);


     }catch(err){


       // notify system api error
       this._router.navigate(['/login']);
       return false;

     }









     }catch(err){

       this._router.navigate(['/login']);
       return false;

     }







  }


  isAuthenticated(): any {

    try{




     let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

     if(!tokenA) throw 'Error in parse';

     if(!JSON.parse(tokenA)) throw 'Error in json parse';


     tokenA = JSON.parse(tokenA);


    try{
      let  httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
          "Authorization": "Bearer "+tokenA.token,
        })
      };

      let api_url =AppSettings.API_ENDPOINT+'auth.php';

      return this.http.post<any>(api_url,{},httpOptions);


    }catch(err){


      // notify system api error
      this._router.navigate(['/login']);
      return false;

    }









    }catch(err){

      this._router.navigate(['/login']);
      return false;

    }





  }

  // simulate jwt token is valid
  // https://github.com/theo4u/angular4-auth/blob/master/src/app/helpers/jwt-helper.ts
  isTokenExpired(): boolean {
    return false;
  }

  loginAdmin(): void {

    localStorage.setItem('token', `eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJPbmxpbmUgSldUIEJ1aWxkZXIiLCJpYXQiOjE1MzMyNzM5NjksImV4cCI6MTU2NDgxMDAwNSwiYXVkIjoid3d3LmV4YW1wbGUuY29tIiwic3ViIjoiVGVzdCBHdWFyZCIsIkdpdmVuTmFtZSI6IkpvaG5ueSIsIlN1cm5hbWUiOiJSb2NrZXQiLCJFbWFpbCI6Impyb2NrZXRAZXhhbXBsZS5jb20iLCJyb2xlIjoiQWRtaW4ifQ.rEkg53_IeCLzGHlmaHTEO8KF5BNfl6NEJ8w-VEq2PkE`);

    this._router.navigate(['/dashboard']);


  }

  login(reqdata:any):any{

    try{
      let  httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json'
        })
      };

      let api_url =AppSettings.API_ENDPOINT+'auth.php';

      this.http.post<any>(api_url,reqdata,httpOptions).subscribe(res => {

        if(res.status=='success'){
           
         // res.role='Admin';

          let resdata=btoa(JSON.stringify(res))
          localStorage.setItem('token',resdata)
          localStorage.setItem('MMEPortalJWT',res.portal_token)
          localStorage.setItem('user',btoa(reqdata.email))
          localStorage.setItem('pending_external', res.pending_external ? res.pending_external : 0)

          let data2={
            event:'login',
            source:'web',
            token:res.token
          }
          this.articleService.analytics(data2).subscribe( (res)=>{

            if(res.status=='success' ){

            }
          })

         // console.log(localStorage.state.indexOf('?'));

          if(localStorage.state!=undefined){


            if(localStorage.state.indexOf('?') !=-1){


              let pos = localStorage.state.indexOf('?');

              let fist = localStorage.state.substr(0,pos);

              let lst = localStorage.state.substr(pos+1);

              this._router.navigate([fist], { queryParams: JSON.parse(localStorage.qr)});

            } else{

              this._router.navigate([localStorage.state]);

            }



           // this._router.navigate([localStorage.state], { queryParamsHandling: "merge" });



          }else{
            this._router.navigate(['/home']);
          }




        }else{


          this.toastr.error(res.message, '', {timeOut: 3000});
          if(window.location.pathname=='/vlogin'){
            this._router.navigate(['/vlogin']);
          }else {
            this._router.navigate(['/login']);
          }

        }

      })
    }catch(err){

       if(window.location.pathname=='/vlogin'){
            this._router.navigate(['/vlogin']);
          }else {
            this._router.navigate(['/login']);
          }
    }



    // localStorage.setItem('token', `eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJPbmxpbmUgSldUIEJ1aWxkZXIiLCJpYXQiOjE1MzMyNzM5NjksImV4cCI6MTU2NDgxMDAwNSwiYXVkIjoid3d3LmV4YW1wbGUuY29tIiwic3ViIjoiVGVzdCBHdWFyZCIsIkdpdmVuTmFtZSI6IkpvaG5ueSIsIlN1cm5hbWUiOiJSb2NrZXQiLCJFbWFpbCI6Impyb2NrZXRAZXhhbXBsZS5jb20ifQ.GA0Y9gYIjmx1jLwuRHuBgZ8m6o-NgkD84nO0ym68CWo`);

    // this._router.navigate(['/dashboard']);

  }

  /**
   * this is used to clear local storage and also the route to login
   */
  logout(token:string):  Observable<any>  {




    try{


            let  httpOptions = {
              headers: new HttpHeaders({
                'Content-Type':  'application/json',
                "Authorization": "Bearer "+token,
              })
            };

            let api_url =AppSettings.API_ENDPOINT+'logout.php';

            return this.http.post<any>(api_url,{},httpOptions);




    }catch(exc){

      this.toastr.error('Something went wrong', '', {timeOut: 3000});

      this.clear();

      this._router.navigate(['/login']);


    }

  }

  decode() {

    try{

      return JSON.parse(atob(localStorage.getItem('token')));

    } catch(ex){
      return {};
    }





  }
}
